import React from 'react';
import TabPropertyType from './components/TabPropertyType';
import TabLocations from './components/TabLocations';
import TabOther from './components/TabOther';
import { IFiltersSelection } from './store/reducer';
import TabAdminFilters from './components/TabAdminFilters';
import TabHeatingAndCooling from './components/TabHeatingAndCooling';
import TabFurnishing from './components/TabFurnishing';
import TabFloor from './components/TabFloor';
import TabBathrooms from './components/TabBathrooms';
import TabWC from './components/TabWC';
import TabSuitableFor from './components/TabSuitableFor';
import TabBasement from './components/TabBasement';
import TabAttic from './components/TabAttic';
import TabTitleDeed from './components/TabTitleDeed';
import TabVAT from './components/TabVAT';
import TabEnergyEfficiency from './components/TabEnergyEfficiency';
import TabPropertyID from './components/TabPropertyID';
import TabPrice from './components/TabPrice';
import TabBedrooms from './components/TabBedrooms';
import TabInternalArea from './components/TabInternalArea';
import TabCondition from './components/TabCondition';
import TabYearBuilt from './components/TabYearBuilt';
import TabPlotSize from './components/TabPlotSize';
import TabZone from './components/TabZone';
import TabBuildingDensity from './components/TabBuildingDensity';
import TabMaxFloors from './components/TabMaxFloors';
import TabFrontage from './components/TabFrontage';
import TabCoveredParking from './components/TabCoveredParking';
import TabROI from './components/TabROI';
import TabLandOptions from './components/TabLandOptions';
import { PriceType } from 'constants/priceType';

export enum PropertyFilterType {
  AdminFilters = 'AdminFilters',
  PropertyID = 'PropertyID',
  PropertyType = 'PropertyType',
  Price = 'Price',
  Location = 'Location',
  Bedrooms = 'Bedrooms',
  InternalArea = 'InternalArea',
  Condition = 'Condition',
  YearBuilt = 'YearBuilt',
  PlotSize = 'PlotSize',
  Zone = 'Zone',
  BuildingDensity = 'BuildingDensity',
  MaxFloors = 'MaxFloors',
  Frontage = 'Frontage',
  LandOptions = 'LandOptions',
  ParkingSpaces = 'ParkingSpaces',
  ReturnOnInvestment = 'ReturnOnInvestment',
  HeatingAndCooling = 'HeatingAndCooling',
  Furnishing = 'Furnishing',
  Floor = 'Floor',
  Bathrooms = 'Bathrooms',
  WC = 'WC',
  SuitableFor = 'SuitableFor',
  Basement = 'Basement',
  Attic = 'Attic',
  TitleDeed = 'TitleDeed',
  VAT = 'VAT',
  EnergyEfficiency = 'EnergyEfficiency',
  Other = 'Other',
}

export interface ITabContentProps {
  selections: IFiltersSelection;
}
export interface IPropertyFilter {
  id: PropertyFilterType;
  translationKey: string;
  defaultValue: string;
  TabContent: React.FC<ITabContentProps>;
}
export const PropertyFilters: Array<IPropertyFilter> = [
  {
    id: PropertyFilterType.PropertyID,
    translationKey: '',
    defaultValue: 'Property ID',
    TabContent: TabPropertyID,
  },
  {
    id: PropertyFilterType.PropertyType,
    translationKey: '',
    defaultValue: 'Property Type',
    TabContent: TabPropertyType,
  },
  {
    id: PropertyFilterType.Price,
    translationKey: '',
    defaultValue: 'Price',
    TabContent: TabPrice,
  },
  {
    id: PropertyFilterType.Location,
    translationKey: '',
    defaultValue: 'Locations',
    TabContent: TabLocations,
  },
  {
    id: PropertyFilterType.Bedrooms,
    translationKey: '',
    defaultValue: 'Bedrooms',
    TabContent: TabBedrooms,
  },
  {
    id: PropertyFilterType.InternalArea,
    translationKey: '',
    defaultValue: 'Internal area (m2)',
    TabContent: TabInternalArea,
  },
  {
    id: PropertyFilterType.Condition,
    translationKey: '',
    defaultValue: 'Condition',
    TabContent: TabCondition,
  },
  {
    id: PropertyFilterType.YearBuilt,
    translationKey: '',
    defaultValue: 'Year Built',
    TabContent: TabYearBuilt,
  },
  {
    id: PropertyFilterType.PlotSize,
    translationKey: '',
    defaultValue: 'Plot size',
    TabContent: TabPlotSize,
  },
  {
    id: PropertyFilterType.Zone,
    translationKey: '',
    defaultValue: 'Zone',
    TabContent: TabZone,
  },
  {
    id: PropertyFilterType.BuildingDensity,
    translationKey: '',
    defaultValue: 'Building Density',
    TabContent: TabBuildingDensity,
  },
  {
    id: PropertyFilterType.MaxFloors,
    translationKey: '',
    defaultValue: 'Max floors',
    TabContent: TabMaxFloors,
  },
  {
    id: PropertyFilterType.Frontage,
    translationKey: '',
    defaultValue: 'Frontage',
    TabContent: TabFrontage,
  },
  {
    id: PropertyFilterType.LandOptions,
    translationKey: '',
    defaultValue: 'Land Options',
    TabContent: TabLandOptions,
  },
  {
    id: PropertyFilterType.Other,
    translationKey: '',
    defaultValue: 'Amenities',
    TabContent: TabOther,
  },
  {
    id: PropertyFilterType.ParkingSpaces,
    translationKey: '',
    defaultValue: 'Parking spaces',
    TabContent: TabCoveredParking,
  },
  {
    id: PropertyFilterType.ReturnOnInvestment,
    translationKey: '',
    defaultValue: 'Return on Investment (ROI)',
    TabContent: TabROI,
  },
  {
    id: PropertyFilterType.HeatingAndCooling,
    translationKey: '',
    defaultValue: 'Heating and Cooling',
    TabContent: TabHeatingAndCooling,
  },
  {
    id: PropertyFilterType.Furnishing,
    translationKey: '',
    defaultValue: 'Furnishing',
    TabContent: TabFurnishing,
  },
  {
    id: PropertyFilterType.Floor,
    translationKey: '',
    defaultValue: 'Floor',
    TabContent: TabFloor,
  },
  {
    id: PropertyFilterType.Bathrooms,
    translationKey: '',
    defaultValue: 'Bathrooms',
    TabContent: TabBathrooms,
  },
  {
    id: PropertyFilterType.WC,
    translationKey: '',
    defaultValue: "WC's",
    TabContent: TabWC,
  },
  {
    id: PropertyFilterType.SuitableFor,
    translationKey: '',
    defaultValue: 'Suitable for',
    TabContent: TabSuitableFor,
  },
  {
    id: PropertyFilterType.Basement,
    translationKey: '',
    defaultValue: 'Basement',
    TabContent: TabBasement,
  },
  {
    id: PropertyFilterType.Attic,
    translationKey: '',
    defaultValue: 'Attic',
    TabContent: TabAttic,
  },
  {
    id: PropertyFilterType.TitleDeed,
    translationKey: '',
    defaultValue: 'Title Deed',
    TabContent: TabTitleDeed,
  },
  {
    id: PropertyFilterType.VAT,
    translationKey: '',
    defaultValue: 'VAT',
    TabContent: TabVAT,
  },
  {
    id: PropertyFilterType.EnergyEfficiency,
    translationKey: '',
    defaultValue: 'Energy Efficiency',
    TabContent: TabEnergyEfficiency,
  },
  // {
  //   id: PropertyFilterType.Amenities,
  //   translationKey: '',
  //   defaultValue: 'Amenities',
  //   TabContent: TabAmenities,
  // },
  {
    id: PropertyFilterType.AdminFilters,
    translationKey: '',
    defaultValue: 'Admin Filters',
    TabContent: TabAdminFilters,
  },
];

interface ISelectOption {
  id: string | number;
  label: string;
}

export const BathroomOptions: Array<ISelectOption> = [
  { id: 1, label: '1' },
  { id: 2, label: '2' },
  { id: 3, label: '3' },
  { id: 4, label: '4' },
  { id: 5, label: '5+' },
];

export const BedroomOptions = BathroomOptions;

export const WCOptions: Array<ISelectOption> = [
  { id: 1, label: '1' },
  { id: 2, label: '2' },
  { id: 3, label: '3' },
  { id: 4, label: '4' },
  { id: 5, label: '5+' },
];

export const PropertySizeOptions: Array<ISelectOption> = [
  { id: 80, label: '80m2' },
  { id: 100, label: '100m2' },
];

export const PriceTypeOptions: Array<ISelectOption> = [
  {
    id: PriceType.SinglePrice,
    label: 'Single Price',
  },
  {
    id: PriceType.PriceRange,
    label: 'Range Price',
  },
];

export const PriceOptions: Array<ISelectOption> = [
  { id: 0, label: '0' },
  { id: 10000, label: '10000' },
  { id: 20000, label: '20000' },
  { id: 30000, label: '30000' },
  { id: 40000, label: '40000' },
  { id: 50000, label: '50000' },
  { id: 60000, label: '60000' },
  { id: 70000, label: '70000' },
  { id: 80000, label: '80000' },
  { id: 90000, label: '90000' },
  { id: 100000, label: '100000' },
  { id: 110000, label: '110000' },
  { id: 120000, label: '120000' },
  { id: 125000, label: '125000' },
  { id: 130000, label: '130000' },
  { id: 140000, label: '140000' },
  { id: 150000, label: '150000' },
  { id: 160000, label: '160000' },
  { id: 170000, label: '170000' },
  { id: 180000, label: '180000' },
  { id: 190000, label: '190000' },
  { id: 200000, label: '200000' },
  { id: 210000, label: '210000' },
  { id: 220000, label: '220000' },
  { id: 230000, label: '230000' },
  { id: 240000, label: '240000' },
  { id: 250000, label: '250000' },
  { id: 275000, label: '275000' },
  { id: 300000, label: '300000' },
  { id: 325000, label: '325000' },
  { id: 350000, label: '350000' },
  { id: 375000, label: '375000' },
  { id: 400000, label: '400000' },
  { id: 425000, label: '425000' },
  { id: 450000, label: '450000' },
  { id: 475000, label: '475000' },
  { id: 500000, label: '500000' },
  { id: 550000, label: '550000' },
  { id: 600000, label: '600000' },
  { id: 650000, label: '650000' },
  { id: 700000, label: '700000' },
  { id: 750000, label: '750000' },
  { id: 800000, label: '800000' },
  { id: 850000, label: '850000' },
  { id: 900000, label: '900000' },
  { id: 950000, label: '950000' },
  { id: 1000000, label: '1000000' },
  { id: 1100000, label: '1100000' },
  { id: 1200000, label: '1200000' },
  { id: 1300000, label: '1300000' },
  { id: 1400000, label: '1400000' },
  { id: 1500000, label: '1500000' },
  { id: 1600000, label: '1600000' },
  { id: 1700000, label: '1700000' },
  { id: 1800000, label: '1800000' },
  { id: 1900000, label: '1900000' },
  { id: 2000000, label: '2000000' },
  { id: 2100000, label: '2100000' },
  { id: 2200000, label: '2200000' },
  { id: 2300000, label: '2300000' },
  { id: 2400000, label: '2400000' },
  { id: 2500000, label: '2500000' },
  { id: 2750000, label: '2750000' },
  { id: 3000000, label: '3000000' },
  { id: 3250000, label: '3250000' },
  { id: 3500000, label: '3500000' },
  { id: 3750000, label: '3750000' },
  { id: 4000000, label: '4000000' },
  { id: 4250000, label: '4250000' },
  { id: 4500000, label: '4500000' },
  { id: 4750000, label: '4750000' },
  { id: 5000000, label: '5000000' },
  { id: 5500000, label: '5500000' },
  { id: 6000000, label: '6000000' },
  { id: 6500000, label: '6500000' },
  { id: 7000000, label: '7000000' },
  { id: 7500000, label: '7500000' },
  { id: 8000000, label: '8000000' },
  { id: 8500000, label: '8500000' },
  { id: 9000000, label: '9000000' },
  { id: 9500000, label: '9500000' },
  { id: 10000000, label: '10000000' },
  { id: 12500000, label: '12500000' },
  { id: 15000000, label: '15000000' },
];

export const PriceOptionsForRent: Array<ISelectOption> = [
  { id: 0, label: '0' },
  { id: 250, label: '250' },
  { id: 300, label: '300' },
  { id: 350, label: '350' },
  { id: 400, label: '400' },
  { id: 450, label: '450' },
  { id: 500, label: '500' },
  { id: 550, label: '550' },
  { id: 600, label: '600' },
  { id: 650, label: '650' },
  { id: 700, label: '700' },
  { id: 750, label: '750' },
  { id: 800, label: '800' },
  { id: 850, label: '850' },
  { id: 900, label: '900' },
  { id: 950, label: '950' },
  { id: 1000, label: '1000' },
  { id: 1500, label: '1500' },
  { id: 2000, label: '2000' },
  { id: 2500, label: '2500' },
  { id: 3000, label: '3000' },
  { id: 3500, label: '3500' },
  { id: 4000, label: '4000' },
];

export const ValueForRent = 29;

export const PublishedOptions: Array<ISelectOption> = [
  { id: 0, label: 'Unpublished' },
  { id: 1, label: 'Published' },
  { id: 2, label: 'All' },
];

export const MODAL_HEIGHT = '75vh';
export const FOOTER_HEIGHT = '70px';

export const FloorOptions: Array<ISelectOption> = [
  { id: 1, label: '1+' },
  { id: 2, label: '2+' },
  { id: 3, label: '3+' },
  { id: 4, label: '4+' },
  { id: 5, label: '5+' },
  { id: 6, label: '6+' },
  { id: 7, label: '7+' },
  { id: 8, label: '8+' },
  { id: 9, label: '9+' },
  { id: 10, label: '10+' },
  { id: 11, label: '11+' },
  { id: 12, label: '12+' },
  { id: 13, label: '13+' },
  { id: 14, label: '14+' },
  { id: 15, label: '15+' },
  { id: 16, label: '16+' },
  { id: 17, label: '17+' },
  { id: 18, label: '18+' },
  { id: 19, label: '19+' },
  { id: 20, label: '20+' },
];

export const CoveredParkingOptions = FloorOptions;

export const RoiOptions: Array<ISelectOption> = [
  { id: 4, label: 'Over 4%' },
  { id: 5, label: 'Over 5%' },
  { id: 6, label: 'Over 6%' },
  { id: 7, label: 'Over 7%' },
  { id: 8, label: 'Over 8%' },
  { id: 9, label: 'Over 9%' },
  { id: 10, label: 'Over 10%' },
];

export const BasementOptions: Array<ISelectOption> = [
  { id: 1, label: 'Yes' },
  { id: 0, label: 'No' },
];

export const AtticOptions = BasementOptions;
export const TitleDeedOptions = BasementOptions;

export const InternalAreaOptions: Array<ISelectOption> = [
  { id: 50, label: '50+' },
  { id: 75, label: '75+' },
  { id: 100, label: '100+' },
  { id: 125, label: '125+' },
  { id: 150, label: '150+' },
  { id: 200, label: '200+' },
  { id: 300, label: '300+' },
  { id: 400, label: '400+' },
  { id: 500, label: '500+' },
];

export const YearBuiltOptions: Array<ISelectOption> = [
  { id: 5, label: '5' },
  { id: 10, label: '10' },
  { id: 15, label: '15' },
  { id: 20, label: '20' },
];

export const PlotSizeOptions: Array<ISelectOption> = [
  { id: 150, label: '150+' },
  { id: 200, label: '200+' },
  { id: 250, label: '250+' },
  { id: 300, label: '300+' },
  { id: 350, label: '350+' },
  { id: 400, label: '400+' },
  { id: 500, label: '500+' },
  { id: 600, label: '600+' },
  { id: 700, label: '700+' },
  { id: 800, label: '800+' },
  { id: 900, label: '900+' },
  { id: 1000, label: '1000+' },
  { id: 1500, label: '1500+' },
  { id: 2000, label: '2000+' },
  { id: 2500, label: '2500+' },
  { id: 3000, label: '3000+' },
  { id: 4000, label: '4000+' },
  { id: 5000, label: '5000+' },
  { id: 6000, label: '6000+' },
  { id: 7000, label: '7000+' },
  { id: 8000, label: '8000+' },
  { id: 9000, label: '9000+' },
  { id: 10000, label: '10000+' },
];

export const BuildingDensityOptions: Array<ISelectOption> = [
  { id: 100, label: 'Over 100%' },
  { id: 110, label: 'Over 110%' },
  { id: 120, label: 'Over 120%' },
  { id: 130, label: 'Over 130%' },
  { id: 140, label: 'Over 140%' },
  { id: 150, label: 'Over 150%' },
  { id: 160, label: 'Over 160%' },
  { id: 170, label: 'Over 170%' },
  { id: 180, label: 'Over 180%' },
  { id: 190, label: 'Over 190%' },
  { id: 200, label: 'Over 200%' },
];

export const MaxFloorsOptions: Array<ISelectOption> = [
  { id: 1, label: '1+' },
  { id: 2, label: '2+' },
  { id: 3, label: '3+' },
  { id: 4, label: '4+' },
  { id: 5, label: '5+' },
  { id: 6, label: '6+' },
  { id: 7, label: '7+' },
  { id: 8, label: '8+' },
  { id: 9, label: '9+' },
  { id: 10, label: '10+' },
  { id: 11, label: '11+' },
  { id: 12, label: '12+' },
  { id: 13, label: '13+' },
  { id: 14, label: '14+' },
  { id: 15, label: '15+' },
  { id: 16, label: '16+' },
  { id: 17, label: '17+' },
  { id: 18, label: '18+' },
  { id: 19, label: '19+' },
  { id: 20, label: '20+' },
];

export const FrontageOptions: Array<ISelectOption> = [
  { id: 16, label: '16+' },
  { id: 18, label: '18+' },
  { id: 20, label: '20+' },
  { id: 22, label: '22+' },
  { id: 24, label: '24+' },
  { id: 26, label: '26+' },
  { id: 28, label: '28+' },
  { id: 30, label: '30+' },
];

export const UpdatedFromOptions: Array<ISelectOption> = [
  { id: 1, label: 'last 1 month' },
  { id: 3, label: 'last 3 months' },
  { id: 6, label: 'last 6 months' },
];

export const PropertyFilterShowHide: { [key: string]: PropertyFilterType[] } = {
  house: [
    PropertyFilterType.PropertyType,
    PropertyFilterType.AdminFilters,
    PropertyFilterType.PropertyID,
    PropertyFilterType.Price,
    PropertyFilterType.Bedrooms,
    PropertyFilterType.PlotSize,
    PropertyFilterType.YearBuilt,
    PropertyFilterType.InternalArea,
    PropertyFilterType.Condition,
    PropertyFilterType.HeatingAndCooling,
    PropertyFilterType.Furnishing,
    PropertyFilterType.Other,
    PropertyFilterType.Bathrooms,
    PropertyFilterType.Basement,
    PropertyFilterType.Attic,
    PropertyFilterType.TitleDeed,
    PropertyFilterType.ReturnOnInvestment,
    PropertyFilterType.EnergyEfficiency,
    PropertyFilterType.Location,
  ],
  apartment: [
    PropertyFilterType.PropertyType,
    PropertyFilterType.AdminFilters,
    PropertyFilterType.PropertyID,
    PropertyFilterType.Price,
    PropertyFilterType.Bedrooms,
    PropertyFilterType.YearBuilt,
    PropertyFilterType.InternalArea,
    PropertyFilterType.Condition,
    PropertyFilterType.Floor,
    PropertyFilterType.HeatingAndCooling,
    PropertyFilterType.Furnishing,
    PropertyFilterType.Other,
    PropertyFilterType.Bathrooms,
    PropertyFilterType.ParkingSpaces,
    PropertyFilterType.TitleDeed,
    PropertyFilterType.ReturnOnInvestment,
    PropertyFilterType.EnergyEfficiency,
    PropertyFilterType.Location,
  ],
  plot: [
    PropertyFilterType.PropertyType,
    PropertyFilterType.AdminFilters,
    PropertyFilterType.PropertyID,
    PropertyFilterType.Price,
    PropertyFilterType.PlotSize,
    PropertyFilterType.BuildingDensity,
    PropertyFilterType.Frontage,
    PropertyFilterType.MaxFloors,
    PropertyFilterType.Zone,
    PropertyFilterType.VAT,
    PropertyFilterType.SuitableFor,
    PropertyFilterType.TitleDeed,
    PropertyFilterType.ReturnOnInvestment,
    PropertyFilterType.Location,
  ],
  land: [
    PropertyFilterType.PropertyType,
    PropertyFilterType.AdminFilters,
    PropertyFilterType.PropertyID,
    PropertyFilterType.Price,
    PropertyFilterType.PlotSize,
    PropertyFilterType.BuildingDensity,
    PropertyFilterType.Frontage,
    PropertyFilterType.MaxFloors,
    PropertyFilterType.Zone,
    PropertyFilterType.VAT,
    PropertyFilterType.LandOptions,
    PropertyFilterType.SuitableFor,
    PropertyFilterType.TitleDeed,
    PropertyFilterType.ReturnOnInvestment,
    PropertyFilterType.Location,
  ],
  office: [
    PropertyFilterType.PropertyType,
    PropertyFilterType.AdminFilters,
    PropertyFilterType.PropertyID,
    PropertyFilterType.Price,
    PropertyFilterType.YearBuilt,
    PropertyFilterType.InternalArea,
    PropertyFilterType.Condition,
    PropertyFilterType.Floor,
    PropertyFilterType.HeatingAndCooling,
    PropertyFilterType.Furnishing,
    PropertyFilterType.Other,
    PropertyFilterType.Bathrooms,
    PropertyFilterType.WC,
    PropertyFilterType.ParkingSpaces,
    PropertyFilterType.TitleDeed,
    PropertyFilterType.ReturnOnInvestment,
    PropertyFilterType.EnergyEfficiency,
    PropertyFilterType.Location,
  ],
  shop: [
    PropertyFilterType.PropertyType,
    PropertyFilterType.AdminFilters,
    PropertyFilterType.PropertyID,
    PropertyFilterType.Price,
    PropertyFilterType.YearBuilt,
    PropertyFilterType.InternalArea,
    PropertyFilterType.Frontage,
    PropertyFilterType.Condition,
    PropertyFilterType.HeatingAndCooling,
    PropertyFilterType.Furnishing,
    PropertyFilterType.Other,
    PropertyFilterType.Bathrooms,
    PropertyFilterType.WC,
    PropertyFilterType.ParkingSpaces,
    PropertyFilterType.TitleDeed,
    PropertyFilterType.ReturnOnInvestment,
    PropertyFilterType.EnergyEfficiency,
    PropertyFilterType.Location,
  ],
  industrial: [
    PropertyFilterType.PropertyType,
    PropertyFilterType.AdminFilters,
    PropertyFilterType.PropertyID,
    PropertyFilterType.Price,
    PropertyFilterType.PlotSize,
    PropertyFilterType.InternalArea,
    PropertyFilterType.Condition,
    PropertyFilterType.TitleDeed,
    PropertyFilterType.ReturnOnInvestment,
    PropertyFilterType.EnergyEfficiency,
    PropertyFilterType.Location,
  ],
  business: [
    PropertyFilterType.PropertyType,
    PropertyFilterType.AdminFilters,
    PropertyFilterType.PropertyID,
    PropertyFilterType.Price,
    PropertyFilterType.InternalArea,
    PropertyFilterType.Location,
  ],
  residential_building: [
    PropertyFilterType.PropertyType,
    PropertyFilterType.AdminFilters,
    PropertyFilterType.PropertyID,
    PropertyFilterType.Price,
    PropertyFilterType.YearBuilt,
    PropertyFilterType.InternalArea,
    PropertyFilterType.Condition,
    PropertyFilterType.TitleDeed,
    PropertyFilterType.ReturnOnInvestment,
    PropertyFilterType.EnergyEfficiency,
    PropertyFilterType.Location,
  ],
  commercial_building: [
    PropertyFilterType.PropertyType,
    PropertyFilterType.AdminFilters,
    PropertyFilterType.PropertyID,
    PropertyFilterType.Price,
    PropertyFilterType.YearBuilt,
    PropertyFilterType.InternalArea,
    PropertyFilterType.Condition,
    PropertyFilterType.TitleDeed,
    PropertyFilterType.ReturnOnInvestment,
    PropertyFilterType.EnergyEfficiency,
    PropertyFilterType.Location,
  ],
};
